<template>
  <v-app id="app">
    <NavBar @drawerChanged="drawer = !drawer" @didTapSearch="dialog = true"/>
    <Drawer :showDrawer="drawer" @drawerChanged="updateDrawer"/>
    <v-content>
      <v-fade-transition mode="out-in">
        <router-view :key="$route.path" />
      </v-fade-transition>
    </v-content>
  </v-app>
</template>

<script>
import NavBar from './components/navigation/NavBar.vue';
import Drawer from './components/navigation/Drawer.vue';

export default {
  components: {
    NavBar, Drawer,
  },
  methods: {
    updateDrawer(value) {
      this.drawer = value;
    },
  },
  data: () => ({
    drawer: false,
    dialog: false,
  }),
};
</script>

<style>
.v-application a {
    color: #0d47a1;
}
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #0d47a1;
  background-color: var(--v-background-base);
}
</style>
